export enum TipoCreditoTomadorConfigEnum {

  DESCONTO_ISS = "(R$) Desconto no ISS",
  DESCONTO_OUTROS_IMPOSTOS = "(R$) Desconto em outros impostos",
  PONTOS = "Pontuação"
}
